import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader  } from '../../Shared/Loader/LoaderSlice';
import { setIsAlreadyHasCallBack } from './GenericWizardBlockSlice';

export const getWizardScreens = createAsyncThunk('genericWizardBlock/getWizardScreens', async (data, thunkAPI) => {
    const state = thunkAPI.getState().genericWizardBlock;

    try {
        const wizardId = state.epiBlockData?.wizardId;
        const result = await ProviderManager.getProviderData('getWizardScreens', [wizardId]);
        return result?.Body;
    } catch (error) {
        //TODO: Go to error page
    }
  });

  export const doCallBack = createAsyncThunk('genericWizardBlock/doCallBack', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().genericWizardBlock;
        const response = await ProviderManager.getProviderData('createIvrCallback', [state.phoneNumberForCallBack, state.epiBlockData.subjectCode]);
        return response;
    } catch (error) {
        console.error(error);
        if(error.errorCode == 3){
            thunkAPI.dispatch(setIsAlreadyHasCallBack());
            thunkAPI.dispatch(goToPage());
        }
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const createMemo = createAsyncThunk('genericWizardBlock/createMemo', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().genericWizardBlock;
        const loginData = thunkAPI.getState().authentication?.loginData;
        const isAuthenticated = loginData?.isFullAuthenticated || loginData?.isOtpAuthenticated || loginData?.isOtpExtendedAuthenticated || loginData?.isSilentOtpAuthenticated;
        const memoCode = state.epiBlockData.memoCode;
        let memoText = '';
        if(state.page?.toLowerCase() == 'successPage'){
            memoText = state.epiBlockData.memoTextSuccess;
        }else if(state.page == 'errorPage'){
            memoText = state.epiBlockData.memoTextError;
        }
        if(isAuthenticated && (memoCode && memoText)){
            const params = {
                memoType: memoCode,
                memoManualTxt: memoText,
            };
            ProviderManager.getProviderData('createMemo', params);
        }
    }
    catch {
    }
});
